import styled from '@emotion/styled';
import { NavLink } from 'react-router-dom';
import { SIDEBAR_WIDTH } from '@styles/globalStyles';

export const Logo = styled.img`
  width: 100px;
  display: block;
  margin: 0 auto 15px;
`;

export const Wrapper = styled.div`
  padding: 30px 0;
  width: ${SIDEBAR_WIDTH}px;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
`;

export const Avatar = styled.div`
  border-radius: 50%;
  width: 34px;
  height: 34px;
  color: #fff;
  font-weight: 400;
  background-color: ${({ theme }) => theme.palette.base};
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Logout = styled.button`
  display: block;
  border: none;
  background-color: transparent;
  width: 34px;
  height: 34px;

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const UserLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 15px;
`;

export const BelowLogo = styled.div`
  flex: 1;
  padding: 15px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const Navigation = styled.nav`
  padding-top: 15px;
  margin: 0 -15px;

  flex: 1;
  overflow-y: auto;

  ul {
    width: 100%;
    display: block;
  }
`;

export const NavigationItem = styled.li``;

export const NavigationItemLink = styled.div`
  display: flex;
  align-items: center;
  color: #fff;
  padding: 15px 15px 15px 45px;
  margin-bottom: 1px;
  text-transform: uppercase;
  background-image: url('/images/icons/${({ icon }) => icon}.svg');
  background-position: 15px 50%;
  background-repeat: no-repeat;
  background-size: 16px;
  font-weight: 300;
  font-size: 16px;
  transition: background-color .3s ease-in-out;
  background-color: ${({ theme }) => theme.palette.base};

  /* &:hover {
    background-color: #2b2b2b;
  } */

  &.active {
    background-color: ${({ theme }) => theme.palette.base};
    font-weight: 600;
  }
  `;

export const Labels = styled.ul``;

export const Label = styled.li`
  & + & {
    margin-top: 1px;
  }
`;

export const LabelLink = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 12px 15px 12px 17px;
  background-color: #2b2b2bc7;
  color: #fff;
  font-size: 12px;
  transition: background-color 0.3s ease-in-out;
  cursor: pointer;

  img {
    display: block;
    width: 12px;
    height: 12px;
    margin-right: 15px;
  }

  &.active {
    background-color: #2b2b2b;
    font-weight: 600;
  }

  &:hover {
    background-color: #2b2b2b;
  }
`;
